<template>
  <v-dialog
    :value="active"
    @click:outside="closeDialog"
    scrollable
    max-width="500"
  >
    <ValidationObserver ref="obs" v-slot="{ handleSubmit }">
      <v-card>
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              Eliminar archivos temporales
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text style="max-height: 350px">
            <v-form>
              <v-row dense justify="center">
                <v-col cols="12">
                  <v-menu
                    ref="dateMenu"
                    v-model="dateMenu"
                    :close-on-content-click="true"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <ValidationProvider
                        name="fecha"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="date"
                          required
                          filled
                          rounded
                          class="rounded-small"
                          label="Fecha"
                          readonly
                          v-on="on"
                          :error-messages="errors"
                        ></v-text-field>
                      </ValidationProvider>
                    </template>
                    <v-date-picker
                      locale="es-us"
                      v-model="date"
                      scrollable
                      no-title
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </vuescroll>

        <v-divider></v-divider>

        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              rounded
              class="mr-1"
              :color="hover ? 'error' : 'grey'"
              @click="closeDialog()"
            >
              Cancelar
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              rounded
              :loading="isLoading"
              color="success"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click="handleSubmit(submitForm)"
            >
              Buscar
            </v-btn>
          </v-hover>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import vuescroll from "vuescroll";
import axios from "axios";
import moment from "moment";

export default {
  props: {
    active: {
      type: Boolean,
    },
    baseUrl: {
      type: String,
    },
    options: {
      type: Object,
    },
  },

  components: {
    vuescroll,
  },

  data() {
    return {
      isLoading: false,
      dateMenu: false,
      date: "",
    };
  },
  methods: {
    closeDialog() {
      this.$emit("dialog:close");
    },
    async submitForm() {
      this.isLoading = true;
      const payload = {
        date: moment(this.date).format("YYYY/MM/DD"),
      };
      try {
        await axios.post(`${this.baseUrl}/api/temporary_table/reset`, payload, {
          ...this.options,
        });
        this.$snotify.success(
          "Registros temporales eliminados con éxito.",
          "¡Hecho!"
        );
        this.closeDialog();
      } catch (err) {
        // console.log(err);
        this.$snotify.error("Hubo un error enviando los datos.", "Error");
      }
      this.isLoading = false;
    },
  },
};
</script>

<style></style>
